import { createAsyncThunk } from '@reduxjs/toolkit'
import ApplicationConf from 'conf/ApplicationConf'
import LogAction from 'log/actions/LogAction'
import i18n from 'simple-react-i18n'
import { REJECTED, IDLE } from 'store/DataManagerConstants'
import ToastrAction from 'toastr/actions/ToastrAction'
import { genericPromise } from 'utils/ActionUtils'

const UserThunk = {
    fetchBookmarks: createAsyncThunk(
        'fetchBookmarks',
        async (_, { rejectWithValue, dispatch }) => {
            try {
                const response = await genericPromise(ApplicationConf.user.getBookmarks(), 'GET')
                return response
            } catch (err) {
                dispatch(LogAction.logError(`${i18n.fetchError} ${i18n.bookmarks} : ${err}`))
                dispatch(ToastrAction.error(`${i18n.fetchError} ${i18n.bookmarks}`))
                return rejectWithValue(err)
            }
        },
        {
            condition: (arg = { forceFetch: false }, { getState }) => {
                const state = getState()
                const { userBookmarksStatus } = state.DataManagerReducer.user
                if (arg.forceFetch) {
                    return userBookmarksStatus !== REJECTED
                }
                return userBookmarksStatus === IDLE
            },
        },
    ),
}

export default UserThunk